import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Modal } from 'bootstrap';
import { debounceTime } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfigService } from 'src/app/services/auth/config.service';
import { BylawsService } from 'src/app/services/bylaws.service';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';

interface Challan {
  challanId: number;
  challanNo: string;
  Amount?: number;
  challanDate: string;
  challanPDFPath?: string;
}

@Component({
  selector: 'app-audit-fee-recovery',
  templateUrl: './audit-fee-recovery.component.html',
  styleUrls: ['./audit-fee-recovery.component.scss']
})
export class AuditFeeRecoveryComponent implements OnInit {
  challanForm!: FormGroup;
  addRecoveryForm!: FormGroup;
  financialYears: any[] = [];
  societyList: any[] = [];
  circlesList: any[] = [];
  months: any[] = [];
  @ViewChild('fileInput') fileInput!: ElementRef;
  selectedFile: File | null = null;
  uploadedFileName: string | null = null;
  challanPDFPath: string | null = null;
  challanList: Challan[] = [];
  filteredData: any[] = [];
  UserDetails: any;
  selectedMonth: number | null = null;
  dropdownSettings = {
    singleSelection: true,              // ✅ single select
    idField: 'challanId',
    textField: 'challanNo',
    enableCheckAll: false,
    allowSearchFilter: true,           // ✅ enables search
    showCheckbox: false,               // ✅ hides the checkboxes
    closeDropDownOnSelection: true,    // ✅ closes dropdown after selecting
    itemsShowLimit: 1
  };
  societydropdownSettings = {
    singleSelection: true,              // ✅ single select
    idField: 'iSocietyDetailsId',
    textField: 'sSocietyName',
    enableCheckAll: false,
    allowSearchFilter: true,           // ✅ enables search
    showCheckbox: false,               // ✅ hides the checkboxes
    closeDropDownOnSelection: true,    // ✅ closes dropdown after selecting
    itemsShowLimit: 1
  };
  minDate!: string;
  maxDate!: string;
  currentFinancialMonth: any;
  monthKeyMap: Record<string, number> = {
    "April": 1,
    "May": 2,
    "June": 3,
    "July": 4,
    "August": 5,
    "September": 6,
    "October": 7,
    "November": 8,
    "December": 9,
    "January": 10,
    "February": 11,
    "March": 12
  };


  constructor(
    private fb: FormBuilder,
    private reportService: ReportsService,
    private toastService: ToastService,
    private ConfigService: ConfigService,
    private cd: ChangeDetectorRef,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.loadUserDetails();
    this.getTargetCount();
    this.currentFinancialMonth = this.getFinancialMonth(new Date());

  }

  initForm() {
    const user = this.authService.currentUserValue;
    if (user) {
      this.UserDetails = user;
    }
    this.challanForm = this.fb.group({
      Id: [null],
      financialYear: ['', Validators.required],
      blockOffice: [''],
      DataMonth: [''],
      ChallanNo: ['', [Validators.required, Validators.maxLength(20)]],
      ChallanDate: ['', Validators.required],
      ChallanPDFPath: ['', Validators.required],
      documentFileName: ['']
    });
    switch (this.UserDetails?.roleId) {
      case 13:

        break;
      case 1:
        this.challanForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
        this.getCircle();
        break;
      case 11:



        break;
      default:
    }
    this.challanForm.get('financialYear')?.valueChanges
      .pipe(debounceTime(300)).subscribe((val: any) => {

        this.getList();


      });

    this.challanForm.get('circleOffice')?.valueChanges
      .pipe(debounceTime(300)).subscribe((val: any) => {
        if (this.challanForm.get('financialYear')?.valid) {

          this.getList();
        }
      });
    this.challanForm.get('blockOffice')?.valueChanges
      .pipe(debounceTime(300)).subscribe((val: any) => {
        if (this.challanForm.get('financialYear')?.valid) {

          this.getList();
        }
      });
    this.addRecoveryForm = this.fb.group({
      recoveries: this.fb.array([])
    });
    this.addRecovery(); // 👈 Add one row by default
  }
  get f() {
    return this.challanForm.controls;
  }
  get recoveries(): FormArray {
    return this.addRecoveryForm.get('recoveries') as FormArray;
  }

  addRecovery() {


    const group = this.fb.group({
      societyId: [null, Validators.required],
      feeAmount: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      challanNo: [null, Validators.required],
      id: [0]
    });

    this.recoveries.push(group);

    setTimeout(() => {
      this.cd.markForCheck();
    }, 0);
  }
  getSocietyDropdownSettings() {
    return { ...this.societydropdownSettings }; // clone fixes the race condition
  }

  removeRecovery(index: number, id: any) {
    this.recoveries.removeAt(index);
    if (id?.value) {
      this.deleteAuditFeeRecovery(Number(id?.value))
    }
  }
  trackByIndex(index: number): number {
    return index;
  }
  submitForm(final?: boolean) {
    if (this.addRecoveryForm.invalid) {
      this.addRecoveryForm.markAllAsTouched();
      return;
    }

    let recoveries: any = this.addRecoveryForm.value?.recoveries
    recoveries?.map((i: any) => {
      i.feeAmount = Number(i?.feeAmount);
      i.challanNo = i?.challanNo.toString();

    })
    const formValues = this.challanForm.getRawValue();
    let obj = {
      "createdBy": this.edit ? 0 : this.UserDetails?.id,
      "modifiedBy": this.edit ? this.UserDetails?.id : 0,
      // id: this.edit ? this.editId : 0,

      "dataMonth": this.monthKeyMap[this.selectedRow?.monthYear.trim()],
      "financialYear": formValues.financialYear.financialYear,


      blockOffice: this.UserDetails?.roleId === 13 ? 0 : this.UserDetails?.iBlockId,

      circleId: this.UserDetails?.roleId == 13 ? this.UserDetails?.iCircleId : 0,

      "auditFeeRecoveryDetails": this.addRecoveryForm.value?.recoveries,
      IsFinalSubmit: final ? 1 : 0
    }


    this.reportService.AddAuditFeeRecovery(obj).subscribe({
      next: (response: any) => {
        if (response) {


          this.toastService.showSuccess(response.message);

          this.addRecoveryForm = this.fb.group({
            recoveries: this.fb.array([])
          });
          this.addRecovery()
          this.hideModal('AuditFeeReport');
          this.getList()
        }

      },
      error: (error: any) => {
        this.toastService.showError(error.message || 'Error fetching data');
      }
    });
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }
  closeChallanModel() {
    this.hideModal('AuditFeeChallanUploadView');
    this.selectedRow = null;
    this.maxDate = '';
    this.minDate = '';
    this.challanForm = this.fb.group({
      Id: [null],
      financialYear: ['', Validators.required],
      blockOffice: [''],
      DataMonth: [''],
      ChallanNo: ['', [Validators.required, Validators.maxLength(20)]],
      ChallanDate: ['', Validators.required],
      ChallanPDFPath: ['', Validators.required],
      documentFileName: ['']
    });
    switch (this.UserDetails?.roleId) {
      case 13:

        break;
      case 1:
        this.challanForm.addControl('circleOffice', new FormControl({
          value: '',
          disabled: false
        }, Validators.required));
        this.getCircle();
        break;
      case 11:



        break;
      default:
    }
    this.challanForm.markAsUntouched()
    this.fileInput.nativeElement.value = '';
  }
  loadUserDetails() {


  }

  onFileChange(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;

    const fileSizeInMB = file.size / (1024 * 1024);
    const allowedExtensions = ['pdf'];
    const ext = this.getFileExtension(file.name);

    if (!allowedExtensions.includes(ext)) {
      this.toastService.showError('Invalid file type. Only PDF allowed.');
      return;
    }

    if (fileSizeInMB > 2) {
      this.toastService.showError('File size must be ≤ 2 MB');
      return;
    }

    this.selectedFile = file;
    this.uploadedFileName = file.name;
    this.challanForm.patchValue({
      ChallanPDFPath: file.name,
      documentFileName: file.name
    });

    this.convertToBase64(file);
    this.cd.detectChanges();
  }

  convertToBase64(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      this.challanPDFPath = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  getFileExtension(fileName: string): string {
    const idx = fileName.lastIndexOf('.');
    return idx !== -1 ? fileName.substring(idx + 1).toLowerCase() : '';
  }
  getTargetCount() {
    let obj = {
      // "action": "GetBIDropdownValue",
      "action": (this.UserDetails?.roleId == 1) ? "GetARDropdownValue" : "GetBIDropdownValue",
      "circleId": this.UserDetails?.iCircleId
    }
    this.reportService.GetTargetCount(obj).subscribe(res => {
      if (res) {
        // this.circlesList = res.data.circles;


        this.financialYears = res.data.financialYears

      }
    },
      (error: any) => {
      }
    );
  }

  getCircle() {

    this.reportService.getCircle().subscribe((res: any) => {
      if (res) {
        // this.circlesList = res.data.circles;
        this.circlesList = res.data.circles;

      }
    },
      (error: any) => {
      }
    );
  }

  GetBlock() {


    let obj = {
      // "action": "GetBIDropdownValue",
      "blockId": 0,
      "circleId": this.challanForm.value?.circleOffice
      // "circleId": 0
    }


    this.reportService.GetBlock(obj).subscribe((res: any) => {

    },
      (error: any) => {
      }
    );
  }

  getList(): void {
    const formValues = this.challanForm.getRawValue();


    const payload = {
      BlockId: this.UserDetails?.roleId === 13 ? 0 : this.UserDetails?.iBlockId,
      FinancialYear: formValues.financialYear.financialYear,
      DataMonth: formValues.DataMonth || new Date().getMonth() + 1,
      CircleId: (this.UserDetails?.roleId == 13) ? this.UserDetails?.iCircleId : this.challanForm.value?.circleOffice ? this.challanForm.value?.circleOffice : 0
    };

    this.reportService.getAuditFeeRecoveryData(payload).subscribe({
      next: (response: any) => {
        this.filteredData = response.data || [];

      },
      error: (error: any) => {
        this.toastService.showError(error.message || 'Error fetching data');
      }
    });
  }
  /** Returns true if a button should be shown/enabled for this row */
  canShowButton(row: any): boolean {
    if (!row.dataMonth) return false; // no dataMonth → hide button
    return row.dataMonth <= this.currentFinancialMonth;
  }

  /** Convert date to your financial month number (April=1...March=12) */
  getFinancialMonth(date: Date): number {
    const jsMonth = date.getMonth(); // 0–11
    // April(3) → 1, May(4) → 2, ..., Dec(11) → 9, Jan(0) → 10, Feb(1) → 11, Mar(2) → 12
    return jsMonth >= 3 ? jsMonth - 2 : jsMonth + 10;
  }
  AuditViewDetails: any[] = []
  getDetails(row: any, view?: any): void {
    const formValues = this.challanForm.getRawValue();


    const payload = {
      BlockId: this.UserDetails?.roleId === 13 ? 0 : this.UserDetails?.iBlockId,
      FinancialYear: row.financialYear,
      DataMonth: row.dataMonth,
      CircleId: this.UserDetails?.roleId == 13 ? this.UserDetails?.iCircleId : 0
    };

    this.reportService.getAuditFeeeRecoveryDetail(payload).subscribe({
      next: (response: any) => {
        this.AuditViewDetails = response.data || [];
        this.prefillRecoveries(this.AuditViewDetails, view)

      },
      error: (error: any) => {
        this.toastService.showError(error.message || 'Error fetching data');
      }
    });
  }

  prefillRecoveries(data: any, view?: any) {
    const prefillData = data

    this.recoveries.clear(); // reset existing entries

    prefillData.forEach((item: any) => {
      const group = this.fb.group({
        societyId: [item?.societyId || null, Validators.required],
        feeAmount: [item?.feeAmount || '', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
        challanNo: [item?.challanNo || null, Validators.required],
        id: [item?.id || 0]
      });

      this.recoveries.push(group);

      // setTimeout(() => {
      //   this.cd.markForCheck();
      // }, 0);
    });

    this.addRecoveryForm = this.fb.group({
      recoveries: this.recoveries
    });
    if (!view) {
      this.openModalView('AuditFeeReport')

    }
    this.cd.markForCheck();


  }

  getTotalDetailAmount(): number {
    return this.AuditViewDetails.reduce((sum, item) => sum + (item.feeAmount || 0), 0);
  }
  edit = false;
  editId = 0
  onSubmit() {

    if (!this.challanForm.valid) {
      this.challanForm.markAllAsTouched();
      return;
    }

    const formValues = this.challanForm.getRawValue();

    const payload = {
      Id: formValues?.Id || 0,
      FinancialYear: formValues.financialYear.financialYear || '',
      // DataMonth: formValues.DataMonth || new Date().getMonth() + 1,
      DataMonth: this.selectedRow?.dataMonth,
      ChallanNo: formValues?.ChallanNo?.trim() || '',
      ChallanDate: formValues?.ChallanDate,
      ChallanPDFPath: this.challanPDFPath || '',
      DocumentFileName: formValues?.documentFileName || '',
      CreatedBy: this.edit ? 0 : this.UserDetails?.id,
      ModifiedBy: this.edit ? this.UserDetails?.id : 0,
      BlockOffice: this.UserDetails?.roleId === 13 ? 0 : this.UserDetails?.iBlockId,
      CircleId: this.UserDetails?.roleId == 13 ? this.UserDetails?.iCircleId : 0
    };


    this.reportService.AddChallan(payload).subscribe({
      next: (res: any) => {
        if (res?.status === 200) {
          this.toastService.showSuccess(res.message);
          const modalEl = document.getElementById('AuditFeeChallanUploadView');
          if (modalEl) {
            const modalInstance = Modal.getInstance(modalEl);
            modalInstance?.hide();
          }
          this.closeChallanModel();
          this.challanPDFPath = ""
        }
      },
      error: () => this.toastService.showError('Something went wrong!')
    });
  }


  getChallanList(row: any) {
    const formValues = this.challanForm.getRawValue();


    const payload = {
      BlockId: this.UserDetails?.roleId === 13 ? 0 : this.UserDetails?.iBlockId,
      FinancialYear: formValues.financialYear.financialYear,
      DataMonth: row.dataMonth,
      CircleId: this.UserDetails?.roleId == 13 ? this.UserDetails?.iCircleId : 0
    };
    this.reportService.getChallanDetail(payload).subscribe({
      next: (response: any) => {
        this.challanList = response.data || [];

      },
      error: (error: any) => {
        this.toastService.showError(error.message || 'Error fetching data');
      }
    });
  }

  /** Sets min/max date for a given dataMonth (1=April ... 12=March) and financial year */
  setMinMaxDates(challanData: any) {
    const { financialYear, dataMonth } = challanData;

    if (!financialYear || !dataMonth) {
      this.minDate = '';
      this.maxDate = '';
      return;
    }

    // Financial year example: "2025-2026"
    const [fyStart, fyEnd] = financialYear.split('-').map(Number);

    // Determine which calendar year this month belongs to
    let year: number;
    let jsMonth: number; // 0-based month index for JS

    if (dataMonth >= 1 && dataMonth <= 9) {
      // April (1) through December (9) belong to start year
      jsMonth = dataMonth + 2; // April(1)=>3 ... December(9)=>11
      year = fyStart;
    } else {
      // January (10), February (11), March (12) belong to next year
      jsMonth = dataMonth - 10; // January(10)=>0, February(11)=>1, March(12)=>2
      year = fyEnd;
    }

    const firstDay = new Date(year, jsMonth, 1);   // ✅ 1st of October
    const lastDay = new Date(year, jsMonth + 1, 0); // ✅ 31st of October


    this.minDate = this.formatDate(firstDay);
    this.maxDate = this.formatDate(lastDay);

  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }



  deleteChallan(id: number) {

    this.reportService.deleteChallan(id).subscribe({
      next: (response: any) => {
        // this.challanList = response.data || [];
        this.challanList = this.challanList.filter((i: any) => i?.challanId != id)
        this.toastService.showError(response.message);
      },
      error: (error: any) => {
        this.toastService.showError(error.message || 'Error fetching data');
      }
    });
  }
  viewChallan(id: number) { }

  getTotalAmount(): number {
    return this.challanList.reduce((sum, x) => sum + (x.Amount || 0), 0);
  }
  openMOdel(row?: any) {
    this.getChallanList(row);

    this.selectedRow = row
    this.setMinMaxDates(row)
  }
  selectedRow: any
  editData(row?: any) {
    this.selectedRow = row;
    this.addRecoveryForm = this.fb.group({
      recoveries: this.fb.array([])
    });
    this.addRecovery();
    this.getSocieties();
    this.getChallanList(row)
    if (row?.societies > 0) {
      setTimeout(() => {
        this.getDetails(row)
      })
    } else {
      this.openModalView('AuditFeeReport')
    }



  }

  openModalView(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }
  //   downloadDocument(path: any) {
  //   if (path) {
  //     const fileUrl = this.ConfigService.getFileUrl() +path;
  //     const link = document.createElement('a');
  //     link.href = fileUrl;
  //     link.target = '_blank'; // Open in a new tab
  //     link.download = fileUrl.split('/').pop() || 'downloaded-file'; // Extract filename from URL
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } else {
  //     this.toastService.showError('Document path is not available');
  //   }
  // }

  downloadDocument(filePath: any) {
    const relativePath = filePath
      .split('UploadedFiles\\')[1]
      ?.replace(/\\/g, '/');

    if (relativePath) {
      const fileUrl = this.ConfigService.getFileUrl() + relativePath;
      const link = document.createElement('a');
      link.href = fileUrl;
      link.download = relativePath.split('/').pop() || 'download';
      link.target = '_blank';
      link.click();
    } else {
      console.error('Invalid file path:', filePath);
    }
  }

  getSocieties() {
    let obj = {
      BlockId: this.UserDetails?.roleId === 13 ? 0 : this.UserDetails?.iBlockId,
      CircleId: this.UserDetails?.roleId == 13 ? this.UserDetails?.iCircleId : 0
    }
    // this.financialYears = [];

    this.reportService.getAuditSocieties(obj).subscribe((res: any) => {
      if (res) {
        this.societyList = res?.data


      }
    },
      (error: any) => {
      }
    );
  }


  closeModel(model: any) {
    this.hideModal(model);
  }

  deleteIndex: any
  setDeleteIndex(index: number) {
    this.deleteIndex = index;
  }
  cancelDelete() {
    this.deleteIndex = 0;

  }

  deleteAuditFeeRecovery(id: any) {
    this.reportService.deleteAuditFeeRecovery(id).subscribe((res: any) => {
      if (res) {

        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          // this.getList();
        }

      }
    },
      (error: any) => {
      }
    );
  }

  verifyAuditFeeRecovery(id: any) {

    this.reportService.verifyAuditFeeRecovery(id).subscribe((res: any) => {
      if (res) {

        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.getList();
        }

      }
    },
      (error: any) => {
      }
    );
  }
}
